(ns ui.view.nev.sidebar
  (:require
   [ui.util :as uu]
   [reagent.core :as r]
   [ui.components.radix-ui.accordion.view
    :refer [accordion-primitive-root
            accordion-primitive-header
            accordion-primitive-trigger
            accordion-primitive-item
            accordion-primitive-content]]
   [ui.components.button.view :as button]
   [ui.view.nev.sub :as sub]
   [ui.view.nev.event :as event]
   [re-frame.core :as rf]
   [oops.core :as oops]
   [frontend.routing :as routing]
   [common.util :as cu]))

(def accordion accordion-primitive-root)

(defn accordion-trigger
  [props & children]
  (let [children (if (map? props)
                   children
                   (cons props children))
        class (when (map? props)
                (:class props))
        props (if (map? props)
                (dissoc props :class)
                {})
        disabled? (:disabled props)]
    [accordion-primitive-header
     {:class "flex"}
     (into
      [accordion-primitive-trigger
       (merge
        {:class (uu/cm "flex flex-1 m-0 px-4 py-3 transition-all font-semibold"
                       (when-not disabled?
                         "")
                       class)}
        props)]

      children)]))

(defn accordion-item
  [props & children]
  (let [children (if (map? props) children (cons props children))
        props (if (map? props) props {})]
    [accordion-primitive-item
     props
     (into [:<>] children)]))

(defn accordion-content
  [props-or-first-child & children]
  (let [props (if (map? props-or-first-child)
                props-or-first-child
                {})
        class (:class props)
        children (if (map? props-or-first-child)
                   children
                   (cons props-or-first-child children))]
    [accordion-primitive-content
     (->
      {:class (uu/cm #_"NevSidebarAccordionContent" ;; HACK: css for getting slide up/down animation working
               "overflow-hidden text-sm m-0"
                     class)}
      (merge (dissoc props :class)))
     (into [:div {:class "py-4 border-b border-solid border-base-light-border-paler"}] children)]))

(defn entity-sections-accordion
  [{:keys [items ctx]}]
  (let [selected-section @(rf/subscribe [::sub/selected-section ctx])]
    [accordion
     {:value (some-> selected-section cu/kw->str)
      :onValueChange (fn [value-str]
                       (rf/dispatch [::event/set-selected-section ctx (keyword value-str)]))}
     (->> items
          (map (fn [{:keys [id title icon-class expandable? items disabled?
                            available-in-nev-2024?
                            no-module-access? helper-text] :as _item}]
                 (let [selected? (= id selected-section)]
                   ^{:key (str id)}
                   [accordion-item
                    {:value (some-> id cu/kw->str)
                     :class "px-4"}
                    [accordion-trigger
                     {:disabled disabled?
                      :class (uu/cm "rounded" (when selected? "bg-primary-light font-bold text-primary-light-text-accent hover:text-base-regular-text-accent border border-solid border-primary-light-border-accent"))}
                     [:div
                      {:class "w-full flex items-center justify-between"}
                      [:div
                       {:class (uu/cm "relative flex items-center gap-2")}
                       [:i {:class (uu/cm icon-class)}]
                       [:span title]]

                      (when disabled?
                        [button/square-secondary-open
                         {:tooltip helper-text}
                         [:i {:class (uu/cm "fal "
                                            (cond no-module-access?
                                                  "fa-lock"
                                                  (not available-in-nev-2024?)
                                                  "fa-eye-slash"
                                                  :else ""))}]])]]
                    (when expandable?
                      [accordion-content
                       [:div
                        {:class "flex flex-col gap-4"}
                        (->> items
                             (map (fn [{:keys [id title on-click]}]
                                    ^{:key (str "item-" id)}
                                    [:div
                                     {:class "ml-6 cursor-pointer hover:text-base-regular-text-accent font-semibold rounded"
                                      :on-click on-click}
                                     title])))]])]))))]))

(defn entity-accordion-item
  [{:keys [ctx] :as props}
   {:keys [id title kicker items entity-type icon-class selected?
           linked-entity? top-level-section-id
           badge-type badge-label open-intra-nev?] :as _item}]
  [accordion-item
   {:id (str "nev-sidebar-item-" id)
    :value id}
   [accordion-trigger
    {:on-click (fn []
                 (if open-intra-nev?
                   (rf/dispatch [::event/set-selected-entity ctx {:entity-id id
                                                                  :entity-type entity-type
                                                                  :top-level-section-id top-level-section-id
                                                                  :linked-entity? linked-entity?}])
                   (routing/open-entity id)))
     :class (uu/cm "relative min-h-20 items-center"
                   (when selected? "border-t-0 border-x-0 border-b border-solid border-base-light-border-paler"))}
    [:div
     {:class "flex gap-3 items-start"}
     [:div
      {:class "w-10 h-10 flex items-center justify-center bg-base-regular rounded"}
      [:i {:class (uu/cm icon-class)}]]
     [:div
      {:class "flex flex-col items-start"}
      [:p
       {:class "text-xs text-base-light-text-paler"}
       kicker]
      [:p
       {:class "font-bold text-lg text-start line-clamp-2"}
       title]

      (when badge-type
        [:div
         {:class "pt-1"}
         [:div
          {:class (uu/cm "text-xs m-0 rounded-full py-1 px-2 flex items-center justify-center"
                         (case badge-type
                           :success "bg-success-light text-success-light-text border border-solid border-success-light-border-paler"
                           :warning "bg-warning-light text-warning-light-text border border-solid border-warning-light-border-paler"
                           :danger "bg-danger-regular text-danger-light-text border border-solid border-danger-light-border-paler"
                           :info "bg-info-light text-info-light-text border border-solid border-info-light-border-paler"
                           ""))}
          badge-label]])]]]
   [accordion-content
    {:class (uu/cm (when selected?
                     "border-t border-x-0 border-b-0 border-base-regular"))}
    [:div
     [entity-sections-accordion
      (merge
       props
       {:items items})]]]])

(defn content
  [{:keys [ctx] :as props}]
  (let [selected-entity-id @(rf/subscribe [::sub/selected-entity-id ctx])
        primary-entity-item @(rf/subscribe [::sub/sidebar-primary-entity-item ctx])
        linked-entity-items @(rf/subscribe [::sub/sidebar-linked-entity-items ctx])]
    [:div
     {:class "flex flex-col "}
     [accordion
      {:value selected-entity-id}
      [entity-accordion-item
       props
       primary-entity-item]

      (->> linked-entity-items
           (map (fn [{:keys [id] :as item}]
                  ^{:key (str id)}
                  [entity-accordion-item props item])))]]))

(defn view
  [_props]
  (let [sidebar-client-position* (r/atom {:top 0
                                          :left 0
                                          :bottom 0
                                          :right 0})]
    (fn [props]
      [:div
       {:ref (fn [ref]
               (when ref
                 (let [rect (oops/ocall ref "getBoundingClientRect")
                       top (oops/oget rect "top")
                       left (oops/oget rect "left")
                       bottom (oops/oget rect "bottom")
                       right (oops/oget rect "right")]
                   (reset! sidebar-client-position* {:top top
                                                     :left left
                                                     :right right
                                                     :bottom bottom}))))
        :class (uu/cm "h-full overflow-hidden overflow-y-auto border border-l-0 border-y-0 w-full")}
       [:div
        {:class "h-full overflow-hidden relative bg-base-light"}
        [:div
         {:id "nev-sidebar-content-container"
          :class "shrink-0 h-full overflow-hidden overflow-y-auto"}
         [content props]]]])))
